import { uploadCareAsset } from '@hooks/useUploadCare'

const fixedDimensions = {
  mobile: {
    width: 450,
    height: 370,
  },
  desktop: {
    width: 1460,
    height: 400,
  },
}


export function getImage(
  deviceWidth: number | undefined,
  uuid: any,
  dimensions?: { width: number; height: number },
) {
  if (!deviceWidth) return
  // if (!dimensions) {
  //   dimensions =
  //     deviceWidth < 480 ? fixedDimensions.mobile : fixedDimensions.desktop
  // }
  const options = {
    preview: ``,
    // scale_crop: `${dimensions.width}x${dimensions.height}/smart`,
    // stretch: 'fill',
    // brightness: '-15',
    // quality: 'best',
  }
  return uploadCareAsset(uuid, options)
}